__turbopack_context__.v({
  "className": "ibm_plex_mono_4a516581-module__xY4nRW__className",
});
